import Cookies from 'js-cookie';
//import PhotoGrid from './photo-grid';
import Team from './teamInfo';

class GetCountries {
  constructor() {
    var _self = this;
    this.defaultCountry = 'ES';

    if ("undefined" !== typeof geolocation_url) {
      var current_country = Cookies.get('selectedCountry');
      if ("undefined" == typeof current_country) {
        /**
         * This is a workaround while we test on Dev environments.
         * Before deployment, the commented lines should be uncommented and the lines alike should be commented
         * geolocation_url's value depends on the environment. Staging and Production (Openweb) won't have WordPress,
         * so WP Admin bar does not exist
         **/
        var xhr = new XMLHttpRequest();
        xhr.open('GET', window.geolocation_url);
        xhr.onload = function () {
          if (xhr.status === 200) {
            Cookies.set('selectedCountry', window.is_dev ? JSON.parse(xhr.responseText).countryCode : JSON.parse(xhr.responseText).data.country);
            _self.parseBodyClasses();

          } else {
            console.log('Request failed.  Returned status of ' + xhr.status);
          }
        };

        var params = window.is_dev ? {
          fields: "countryCode",
        } : {
          project: "j95bw15y",
        };
        xhr.send(JSON.stringify(params));
      } else {
        this.parseBodyClasses( this.defaultCountry );
      }
    } else {
      this.parseBodyClasses( this.defaultCountry );
    }

    this.opportunities_item_template = '<a href="##OPPORTUNITYURL##">##OPPORTUNITY##</a>';
    this.events_set = false;
  }

  parseBodyClasses( country ) {
    var body_classes = document.querySelector("body").getAttribute("class");
    var arr_classes = body_classes.split(" ");
    for (var i = 0; i < arr_classes.length; i++) {
      if (arr_classes[i].indexOf("page-template-") >= 0) {
        if (arr_classes[i].replace("page-template-", "") == "teams-page") {
          this.getGeoInfo( country );
          new Team();
          return;
        }
      }
    }
  }

  getGeoInfo(country) {
    // var tpl_disciplines = '<div class="label">##DISCIPLINE##</div>';
    if ("undefined" != typeof geo_data) {
      var current_country = (null == country) ? Cookies.get('selectedCountry') : country;
      //Clear active status from li and a
      if (null != country && null != document.querySelector("#menu-countries li.no-click.active")) {
        document.querySelector("#menu-countries li.no-click.active").classList.remove("active");
        document.querySelector("#menu-countries li.no-click a.active").classList.remove("active");
      } else if (null != country && null != document.querySelector("#menu-countries-spanish li.no-click.active")) {
        document.querySelector("#menu-countries-spanish li.no-click.active").classList.remove("active");
        document.querySelector("#menu-countries-spanish li.no-click a.active").classList.remove("active");
      }

      //I just want the first, but I'll check if there's more than one
      if (window.geo_data[current_country].data.length) {
        var data = window.geo_data[current_country].data[0];

        document.querySelector("h1.entry-title").innerText = data.title;
        document.querySelector("#description").innerHTML = data.content;

        // document.querySelector(".countries-team__image-description img").setAttribute('title', data.team_image_title);

        // var disciplines = "";
        // if (data.disciplines.length > 0) {
        //   for (var i = 0; i < data.disciplines.length; i++) {
        //     disciplines += tpl_disciplines.replace("##DISCIPLINE##", data.disciplines[i]);
        //   }
        // }
        // document.querySelector("#disciplines").innerHTML = disciplines;

        /*var opportunities = "";
        for ( var k=0; k < data.opportunities.length; k++ ){
        	opportunities += this.opportunities_item_template.replace("##OPPORTUNITYURL##", data.opportunities[k].url)
        		.replace("##OPPORTUNITY##", data.opportunities[k].title);
        }
        document.querySelector("#opportunities p").innerHTML = opportunities;*/


        // if ("undefined" != typeof window.ExperienceTheme) {
        //   window.ExperienceTheme.photoGrid.setupGallery(data.gallery);
        // } else {
        //   document.addEventListener("DOMContentLoaded", () => {
        //     window.ExperienceTheme.photoGrid.setupGallery(data.gallery);
        //   });
        // }

        //Change header language link with translation
        //document.querySelector("#translate-to-link").setAttribute("href", data.translation);

        //Activate menu item according to selected geo
        if (document.querySelector("#menu-countries")) {
          document.querySelector("#menu-countries a[data-iso='" + current_country + "']").classList.add('active');
          document.querySelector("#menu-countries a[data-iso='" + current_country + "']").parentElement.classList.add('active');
        } else if (document.querySelector("#menu-countries-spanish")) {
          document.querySelector("#menu-countries-spanish a[data-iso='" + current_country + "']").classList.add('active');
          document.querySelector("#menu-countries-spanish a[data-iso='" + current_country + "']").parentElement.classList.add('active');
        }

        if (!this.events_set) {
          this.loadEvents();
        }
      }
    }
  }

  loadEvents() {
    var _self = this;
    //Add event listener to geo menu items
    var geo_links = document.querySelectorAll("div.teams-submenu li.no-click a");
    for (var i = 0; i < geo_links.length; i++) {
      geo_links[i].addEventListener('click', function (event) {
        event.preventDefault();
        Cookies.set('selectedCountry', this.getAttribute('data-iso'));
        _self.getGeoInfo(this.getAttribute('data-iso'));
      });
    }
    this.events_set = true;
  }
}
export default GetCountries
